import { useEffect, useState } from "react";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

const useOpportunitiesProduct = () => {
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState<{ id: number }>(null);
  useEffect(() => {
    setLoading(true);
    caseTransformingAxios
      .get("/products/opportunities_product_for_account")
      .then((response) => {
        setLoading(false);
        setProduct(response.data as { id: number });
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error fetching opportunities product:", error);
      });
  }, []);
  return { loading, product };
};

export default useOpportunitiesProduct;
